import { Component, Inject } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NotificationBar } from 'src/services/notification.service';
import { AngularFireFunctions } from '@angular/fire/compat/functions';

@Component({
  selector: 'app-settings-owner',
  templateUrl: './settings-owner.component.html',
  styleUrl: './settings-owner.component.scss'
})
export class SettingsOwnerComponent {
  workspaceGroup = new FormGroup({
    emailControl: new FormControl('', [Validators.required, Validators.email])
  });
  isProcessing = false;
  notificationBar: NotificationBar;
  workspaceID = ""
  
  constructor(public dialogRef: MatDialogRef<SettingsOwnerComponent>, @Inject(MAT_DIALOG_DATA) public data: any, private snackBar: MatSnackBar, private fireFunctions: AngularFireFunctions) {
    this.notificationBar = new NotificationBar(snackBar);
    this.workspaceID = data.workspaceID;
  }

  ngOnInit() {

  }

  async updateWorkspaceOwner() {
    this.isProcessing = true;
    var newOwnerEmail = this.workspaceGroup.controls.emailControl.value;
    var workspaceID = this.workspaceID;
    this.fireFunctions.httpsCallable("esportsms-updateWorkspaceOwner")({newOwnerEmail, workspaceID}).subscribe( res => {
      this.isProcessing = false;
      if (res) {
        this.notificationBar.show("Owner updated!");
        this.dialogRef.close(res);
      }
      else {
        this.notificationBar.show("User not found!");
      }
    }, err => {
      this.isProcessing = false;
      if (err.code == "functions/not-found") {
        this.notificationBar.show("User not found!");
      }
      else if (err.code == "functions/permission-denied") {
        this.notificationBar.show("Missing permission!");
      }
      else {
        this.notificationBar.showUnknownError();
      }
    });
  }

  getErrorEmail() {
    return this.workspaceGroup.controls.emailControl.hasError('email') ? 'Not a valid email' : '';
  }
}
